var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgFormBottomNavyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 93,
    viewBox: "0 0 1439 93",
    fill: "#021F2B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1356.76 79.478C1383.96 67.882 1407.28 54.2233 1426 25.5C1432.1 16.1356 1439 0 1439 0L-1 -0.000125889C-1 -0.000125889 9.39721 26.3498 49.9775 33.6083L1251.79 91.7872C1281.17 95.328 1329.54 91.0833 1356.76 79.478Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFormBottomNavyDark);
export default __webpack_public_path__ + "static/media/bg-form-bottom-navy-dark.fe5ee1ec07c38193231f4933d6cb6d7f.svg";
export { ForwardRef as ReactComponent };